export default __webpack_public_path__ + "static/media/Ellipse.36b7410e.png";